export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('link');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    const TRAITS_REL_OPTION_DISABLED_VALUE = "disabled";
    const TRAITS_REL_OPTION_SPONSORED_VALUE = "sponsored";
    const TRAITS_REL_OPTION_UGC_VALUE = "ugc";
    const TRAITS_REL_OPTION_NOFOLLOW_VALUE = "nofollow";

    DOMC.addType('link', {
        isComponent(el) {
            if (el.tagName === 'A') {
                return { type: 'link' };
            }
        },
        extend: 'link',
        model: {
            defaults: {
                traits: MODEL.prototype.defaults.traits.concat([
                    {
                        type: 'select',
                        options: [
                            { id: TRAITS_REL_OPTION_DISABLED_VALUE, name: 'Disabled' },
                            { id: TRAITS_REL_OPTION_SPONSORED_VALUE, name: 'Sponsored' },
                            { id: TRAITS_REL_OPTION_UGC_VALUE, name: 'Ugc' },
                            { id: TRAITS_REL_OPTION_NOFOLLOW_VALUE, name: 'Nofollow' },
                        ],
                        name: 'rel',
                        label: 'rel'
                    },
                ])
            },
            init() {
                this.on('change:attributes:rel', () => {
                    let attrs = this.getAttributes();
                    if (attrs.rel == "disabled")
                    {
                        this.removeAttributes('rel');
                    }
                });
            },
        },
    });
}
